import { Form, Formik } from 'formik';
import { ButtonPrimary } from '../../components/Button/ButtonPrimary';
import { ErrorMessageLabel } from '../../components/ErrorMessageLabel/ErrorMessageLabel';
import { InputField } from '../../components/InputField/InputField';
import { StorageStand } from '../../../models/Storage/StorageStand';
import { StorageRoom } from '../../../models/Storage/StorageRoom';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useQuery } from '@tanstack/react-query';
import * as Yup from 'yup';
import { Select } from 'antd';

function CreateStorageStand() {
  const { data: rooms = [], isLoading } = useQuery(
    ['storage-rooms'],
    StorageRoom.all
  );

  return (
    <>
      <h1 className="cs-title">Dodaj Skladišnu Policu</h1>
      <Formik
        initialValues={{ name: '', storage_room_id: null }}
        validationSchema={Yup.object({
          name: Yup.string().required('Naziv je obavezan'),
          storage_room_id: Yup.number().nullable().required('Soba je obavezna')
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          StorageStand.store(values)
            .then(() => {
              resetForm();
              toast.success('Polica uspešno dodata!');
            })
            .catch((error) => {
              toast.error(
                error?.response?.data?.message || 'Greška pri snimanju.'
              );
            })
            .finally(() => setSubmitting(false));
        }}
      >
        {({ setFieldValue, isSubmitting, values, errors, touched }) => (
          <Form autoComplete="off" className="cs-form-wrapper">
            <FormGroup>
              <Col lg={6}>
                <FormLabel>Naziv police</FormLabel>
                <InputField placeholder="Naziv police" name="name" />
                <ErrorMessageLabel name="name" />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col lg={6}>
                <FormLabel>Pripadajuća prostorija</FormLabel>
                <Select
                  style={{ width: '100%' }}
                  placeholder="Izaberi Prostoriju"
                  value={values.storage_room_id ?? undefined}
                  onChange={(value) => setFieldValue('storage_room_id', value)}
                  options={rooms.map((room) => ({
                    value: room.id,
                    label: room.name
                  }))}
                  status={
                    errors.storage_room_id && touched.storage_room_id
                      ? 'error'
                      : ''
                  }
                />
                <ErrorMessageLabel name="storage_room_id" />
              </Col>
            </FormGroup>
            <ButtonPrimary
              type="submit"
              disabled={isSubmitting || isLoading || rooms.length === 0}
            >
              Sačuvaj
            </ButtonPrimary>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default CreateStorageStand;
